import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0160bc1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-rounded tw-max-w-fit tw-overflow-hidden tw-truncate"
}
const _hoisted_2 = { class: "expand-text tw-font-normal" }

import { IAssessmentNotApplicableTagColor } from "@/interfaces/assessments/IAssessmentDetails";
import { getComponentUiText } from "@/utils/utilities";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentQuestionNotApplicableTag',
  props: {
  color: {
    type: String as PropType<IAssessmentNotApplicableTagColor>,
    required: true,
  },
  numberQuestion: { type: String, default: "", required: true },
  text: { type: String, default: "", required: false },
  expand: { type: Boolean, default: false, required: true },
  prefilled: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tag-container tw-cursor-default tw-flex tw-items-center tw-w-fit tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-font-medium tw-rounded ${
      props.color
    } ${props.expand ? 'contract' : ''}`)
  }, [
    (__props.prefilled)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.numberQuestion +
        " " +
        _unref(getComponentUiText)(
          "app-component-assessments-question-not-applicable-tag-1",
        )), 1))
      : _createCommentVNode("", true),
    _createTextVNode("  "),
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.text), 1)
  ], 2))
}
}

})